import request from '@/utils/request'

/**
 * 获取社区列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含社区列表的Promise对象
 */
export function listCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditCommunityManage/list',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核社区状态
 * @param {Object} data 审核数据
 * @returns {Promise} 包含审核结果的Promise对象
 */
export function auditCommunityState(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditCommunityManage/audit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除社区
 * @param {Object} data 删除数据
 * @returns {Promise} 包含删除结果的Promise对象
 */
export function deleteCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditCommunityManage/delete',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}